
import Section from '../components/Section'

function Person({ name, role, text }: { name: string; role: string; text: string }) {
  return (
    <div className="rounded-2xl glass p-6">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-xl font-semibold">{name}</h3>
          <p className="text-slate-400">{role}</p>
        </div>
      </div>
      <p className="mt-3 text-slate-300 leading-relaxed whitespace-pre-line">
        {text}
      </p>
    </div>
  )
}

export default function About() {
  return (
    <Section title="Über uns" subtitle="Zwei Marcs, eine GbR – M2 Websolutions.">
      <div className="grid gap-6 md:grid-cols-2">
        <Person
          name="Marc Ehrlich"
          role="Fullstack-Developer"
          text={`Neugierig und fokussiert – Full-Stack von Datenmodell bis UI.

• Stärken: Microservice-Denken, klare APIs, saubere Versionierung & Dokus
• Erfahrung: Stripe-Integrationen, Cloud-Uploads (Cloudinary), PDF-Zertifikate
• Haltung: Saubere Architekturen, neuen Technologien und klaren Dokus

 "Nerd für saubere Architekturen, und klare Dokus."`

          }
        />
        <Person
          name="Marc Springer"
          role="DevOps- & Cloud-Engineer"
          text={`Vom Reverse-Proxy bis zum Cluster – klar strukturierte Cloud-Infrastruktur.

• Stärken: Nginx-Proxying, Docker/Compose, Healthchecks & Readiness
• Schnittstellen: saubere API's, BFF-Pattern, robustes Error-Handling
• Datenflüsse: Besitzzuordnung, Rollen/JWT, nachvollziehbare Payment-States

"Geek für Securitystandarts, Transparenz und kontrollierte Releases."`}
        />

      </div>
      <div className="mt-10 rounded-2xl glass p-6">
        <h3 className="font-semibold">Die GbR</h3>
        <p className="mt-2 text-slate-300">
          M2 Websolutions GbR wir sind zwei Entwickler, die sich aus echter Motivation zusammengetan haben: saubere Architektur,
          klare Systeme, ehrliche Umsetzung.
          Wir entwickeln Web- und Cloud-Lösungen mit klarer Architektur und Microservices.
          Ebenso arbeiten wir remote, sauber / versioniert und gut dokumentiert. So liefern wir in kleinen, nachvollziehbaren Schritten –
          stabil, sicher und wartbar.
        </p>
      </div>
    </Section>
  )
}
